<ng-container *ngIf="images$ | async as images">
	<div class="image-container">
		<app-reclamation-finish-image-upload *ngFor="let num of images; index as i" [index]="i" (finished)="handleNewImageUploaded($event, i)"></app-reclamation-finish-image-upload>
	</div>
</ng-container>
